module.exports = __webpack_public_path__ + "startpage-746fed5a/template-1-preview-78faf19c2fc1b3c1ee6790e6dcd0ebdb.jpg";